/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Thai (Thailand)
export default {
  'proforma-jira-portal-create.error-flag-handler.portal-create-view-object-search-error-description':
    'ขอความช่วยเหลือจากทีมหรือผู้ดูแลระบบของคุณ',
  'proforma-jira-portal-create.error-flag-handler.portal-create-view-object-search-error-title':
    'เราไม่สามารถดึงผลลัพธ์ใด ๆ สำหรับการค้นหานี้',
};
